// extracted by mini-css-extract-plugin
export default {"icon":"BackToTopButton__icon--23W","wrapper":"BackToTopButton__wrapper--gi4"};